export interface AtsMessage {
  entityType: AtsEntity;
  externalLastUpdate: string;
  externalId: string;
  atsName: AtsProviders;
  status: string;
}

export enum AtsEntity {
  JOBS = 'JOBS',
  CANDIDATES = 'CANDIDATES',
  APPLICATIONS = 'APPLICATIONS'
}

export enum AtsProviders {
  HCM = 'HCM'
}
